import { createI18n } from 'vue-i18n';
import LocaleManager from '@/i12e/i18n/localeManager';

// Importing your locales object which contains translations
import locales from './locales';

// Create the Vue I18n instance
const i18n = createI18n({
  // Setting the initial locale based on user preference or default
  locale: LocaleManager.activeLocale,
  // Fallback locale is the ultimate fallback defined in LocaleManager
  fallbackLocale: LocaleManager.fallbackLocale,
  // Use the Composition API mode
  legacy: false,
  // Allow global properties like $t in templates
  globalInjection: true,
  // The locale messages
  messages: locales
});

LocaleManager.addEventListener('locale-changed', () => {
  i18n.global.locale.value = LocaleManager.activeLocale;
});

export default i18n;
